.migration-step-list{
    padding: 0;
    display: flex;
    gap: 1.5rem;
    list-style: none;
}

.cpop-logo-container{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    margin-bottom: 24px;
}

.cpop-migration-container{
    display: flex;
    flex-direction: column;
    align-items: center;
}

.cpop-migration-content{
    width: 600px;
}

.cpop-login-panel-container{
    padding: 24px 32px;
    width: 100%;
    max-width: 600px;
}


.migration-step-list .active{
    font-weight: bold;
}

#google-login{
    width: 100%;
}

.cpop-signin-select{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}

.cpop-email-signin{
    width: 100%;
}

.cpop-login-panel{
    display: flex;
    flex-direction: column;
    align-items: center;
}

.cpop-logo{
    width: 48px;
    height: 48px;
}

.cpop-logo-header{
    margin: 0;
}

.cpop-submit-button{
    margin-top: 24px;
}

.cpop-login-panel .google-signin-container, .cpop-login-panel .facebook-signin-container, .cpop-login-panel .or-header{
    width: 100%;
}

.cpop-login-panel .or-header.or-header-narrow{
    margin: 16px 0;
}

.cpop-signin-email-field{
    margin-bottom: 32px!important;
}

.cpop-account-details-container{
    width: 100%;
    padding: 24px 32px;
    margin-bottom: 16px;
}

.cpop-signup-buttons{
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    margin-top: 24px;
}

.cpop-signup-buttons .btn-new{
    width: unset;
    padding: 8px 32px;
}

.btn-new.back-btn{
    background: none;
    cursor: pointer;
}

.payment-method-buttons{
    margin-top: 8px;
}

.migration-status-loading-container{
    display: flex;
    height: 100%;
    width: 100%;
}

.migration-status-loading-content{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.cpop-additional-copy{
    margin-bottom: 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 38%);
}

.cpop-migration-container .read-only-field label{
    font-weight: bold;
    line-height: 1rem;
    letter-spacing: .5px;
    margin-bottom: 8px;
}